import React from 'react';
import { Checkbox, Form } from 'antd';
import styled from 'styled-components';

import { FormFieldLabel } from './FormFieldLabel';

export const StyledFormItem = styled(Form.Item)`
  margin-bottom: 0;
  padding-left: 4px;
`;

const StyledCheckbox = styled(Checkbox)`
  .ant-checkbox-inner,
  .ant-checkbox-input {
    transform: scale(1.25);
  }
`;

export type FormCheckboxProps = {
  name: string | string[];
  label?: string;
  required?: boolean;
};

export const FormCheckbox: React.FC<FormCheckboxProps> = ({ name, label, required }) => {
  return (
    <StyledFormItem name={name} valuePropName="checked">
      <StyledCheckbox>
        <FormFieldLabel required={required}>{label}</FormFieldLabel>
      </StyledCheckbox>
    </StyledFormItem>
  );
};
